import {
  ResponsiveContainer, ComposedChart, Line, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';

export function TrendChart({
  data,
  showClicks,
}: {
  data: Array<{ label: string; clicks: number; conversions: number; revenue: number }>;
  showClicks: boolean;
}) {
  return (
    <div className="h-64 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={data} margin={{ top: 8, right: 12, bottom: 0, left: 0 }}>
          <CartesianGrid stroke="#1f2940" strokeDasharray="3 3" />
          <XAxis dataKey="label" tick={{ fill: '#5a6485', fontSize: 10, fontFamily: 'JetBrains Mono' }} tickLine={false} axisLine={{ stroke: '#1f2940' }} />
          <YAxis tick={{ fill: '#5a6485', fontSize: 10, fontFamily: 'JetBrains Mono' }} tickLine={false} axisLine={false} width={48} />
          <Tooltip
            contentStyle={{ background: '#0f1424', border: '1px solid #00ffe1', borderRadius: 4, fontFamily: 'JetBrains Mono', fontSize: 11 }}
            labelStyle={{ color: '#e8edf7' }}
            itemStyle={{ color: '#9aa3bb' }}
          />
          <Legend wrapperStyle={{ fontFamily: 'JetBrains Mono', fontSize: 11, color: '#9aa3bb' }} />
          {showClicks && <Area type="monotone" dataKey="clicks" name="Clicks" stroke="#00ffe1" fill="rgba(0,255,225,0.08)" strokeWidth={2} />}
          <Line type="monotone" dataKey="conversions" name="Conversions" stroke="#ff2bd6" strokeWidth={2} dot={false} />
          <Line type="monotone" dataKey="revenue" name="Revenue" stroke="#fff200" strokeWidth={2} dot={false} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
